export default String.raw`
$(document).ready(function () {
    lookbook.init();
});

const lookbook = (function () {
    const $container = $('.lookbook');
    const $loobookItems = $container.find('.lookbook__item');
    const $pointIcon = $('<svg class="point__svg"><use href="css/img/fontawesome-icons.svg?v=' + __lqTS + '#dot-circle-'+__iconStyle+'"></use></svg>');

    const init = function () {
        renderButtons();
        renderPoints();
        events();
    }

    const addAllToCart = (parameters) => {
        if (parameters.length > 0) {
            parameters = JSON.stringify(parameters);
            $.post(null, { __action: 'Cart/Add', __csrf: __CSRF, __parameters: parameters, __template: 'partials/common/header/client-area.html', __collection: 'customer.Cart.Id' }, (result) => {
                const products = result.action.Products;
                const productsForDataLayer = [];
                const productsForGA4DataLayer = [];
                const productsForFBPixel = [];
                const productsForTTPixel = [];
                const productsForSCPixel = [];
                let totalValue = 0;
                let basicUnitTotalValue = 0;
                for (const product of products) {
                    const productDL = { id: product.Id.toString(), name: product.NameNoHtml, price: product.BasicUnitTotalPrice, quantity: product.BasicUnitQuantity };
                    const productGA4DL = { item_id: product.Id.toString(), item_name: product.NameNoHtml, price: product.TotalPrice, quantity: product.Quantity };
                    const productFBP = { id: product.Id.toString(), content_name: product.NameNoHtml, value: product.BasicUnitTotalPrice, quantity: product.BasicUnitQuantity };
                    const productTTP = { content_id: product.Id.toString(), content_name: product.NameNoHtml, price: products.BasicUnitTotalPrice, quantity: products.BasicUnitQuantity };
                    totalValue += product.TotalPrice * product.Quantity;
                    basicUnitTotalValue += product.BasicUnitTotalPrice * product.BasicUnitQuantity;
                    productsForDataLayer.push(productDL);
                    productsForGA4DataLayer.push(productGA4DL);
                    productsForFBPixel.push(productFBP);
                    productsForTTPixel.push(productTTP);
                    productsForSCPixel.push(product.Id.toString());
                }

                const dataLayerProds = {
                    "products": productsForDataLayer
                };

                window.dataLayer.push({
                    "event": "addToCart",
                    "ecommerce": {
                        "currencyCode": __currCode,
                        "add": dataLayerProds
                    }
                });

                if (typeof gtag != 'undefined') {
                    gtag("event", "add_to_cart", {
                        currency: __currCode,
                        value: totalValue,
                        items: productsForGA4DataLayer
                    });
                }

                if (typeof _edrone !== 'undefined') {
                    _edrone.action_type = 'add_to_cart';
                    _edrone.init();
                }

                if (typeof fbq !== 'undefined') {
                    fbq('track', 'AddToCart',
                        {
                            value: basicUnitTotalValue,
                            currency: __currCode,
                            content_type: 'product',
                            contents: productsForFBPixel
                        }
                    );
                }

                if(typeof ttq !== 'undefined') {
                    ttq.track('AddToCart',
                        {
                            value: basicUnitTotalValue,
                            currency: __currCode,
                            content_type: 'product',
                            contents: productsForTTPixel
                        }
                    );
                }

                if(typeof snaptr !== 'undefined') {
                    snaptr('track', 'ADD_CART',
                        {
                            price: basicUnitTotalValue,
                            currency: __currCode,
                            items_ids: productsForSCPixel,
                            number_items: i,
                            client_dedup_id: 'ADD_CART_' + new Date().getTime()
                        }
                    );
                }
                
                if (result.action.Result) {
                    if (window.app.getCookie('lastCartId') == undefined || window.app.getCookie('lastCartId') == -1 || window.app.getCookie('lastCartId') == '') {
                        const cartId = result.collection;
                        window.app.setCookie("lastCartId", cartId);
                    }

                    $('.client-area-js').html(result.template);

                    app.serverMessage(result, $container, $container);
                } else {
                    app.serverMessage(result, $container, $container);
                }
            });
        }
    }

    const events = () => {
        $container.on("mouseenter", ".point", handlePointHover);

        $container.on("click", ".point", handlePointHover);

        $container.on("mouseleave", ".point", function () {
            $(this).attr('aria-expanded', 'false');
        });

        $container.on("focusout", ".point", function (e) {
            if (!$(this).has(e.relatedTarget).length && this !== e.relatedTarget) {
                $(this).attr('aria-expanded', 'false');
            }
        });

        $container.on("keydown", function(e) {
            if (e.key === "Escape" || e.keyCode === 27) {
                $container.find('.point[aria-expanded="true"]').attr('aria-expanded', 'false');
            }
        });
    }

    const renderButtons = () => {
        $loobookItems.each(function () {
            const productsJSON = $(this).data('lookbook-products');

            let hasAtributes = false;
            const parameters = [];
            if (productsJSON !== "" && productsJSON !== undefined) {
                for (const product of productsJSON) {
                    let productQuantity = product.quantity;
                    if (productQuantity === "") {
                        productQuantity = 1;
                    }
                    parameters.push({ "productId": product.id, "quantity": productQuantity });
                    if (product.hasAttributes === "true") {
                        hasAtributes = true;
                    }
                }

                const $buttons = $(this).find(".button__group");
                const $cartButton = $(this).find(".button__group .add-all-to-cart-js");
                const $wishButton = $(this).find(".button__group .add-all-to-wishlist-js");
                if (!hasAtributes && productsJSON.length !== 0) {
                    $buttons.css("visibility", "visible");
                }

                $cartButton.on("click", () => addAllToCart(parameters));
                $wishButton.on("click", () => $(this).data("clicked", "true"));
            }
        });
    }

    const renderPoints = () => {
        $loobookItems.each(function () {
            const productsJSON = $(this).data('lookbook-products');
            const $documentFragment = $(document.createDocumentFragment());

            if (productsJSON !== "" && productsJSON !== undefined) {
                productsJSON.forEach(product => {
                    const productQuantity = product.quantity || 1;
                    const $point = $('<div>', {
                        role: 'button',
                        tabindex: 0,
                        class: 'point',
                        css: {
                            left: product.left,
                            top: product.top
                        },
                        'aria-expanded': 'false',
                        'data-product-id': product.id,
                        'data-quantity': productQuantity,
                        'data-is-phantom': product.hasAttributes
                    });
    
                    const leftPosition = parseFloat(product.left.replace('%', ''));
                    const topPosition = parseFloat(product.top.replace('%', ''));
    
                    $point.append($pointIcon.clone());
                    
                    let productWrapperClass = "lookbook__item-product";
                    if (leftPosition >= 30 && leftPosition <= 70) {
                        productWrapperClass += " middle";
                    }
                    
                    const productWrapperCss = {
                        top: '',
                        bottom: '',
                        left: '',
                        right: ''
                    };
                    
                    if (topPosition <= 50) {
                        productWrapperCss.top = '28px';
                    } else {
                        productWrapperCss.bottom = '28px';
                    }
                    
                    if (leftPosition <= 50) {
                        productWrapperCss.left = '28px';
                    } else {
                        productWrapperCss.right = '28px';
                    }
                    
                    const $productWrapper = $('<div>', {
                        class: productWrapperClass,
                        css: productWrapperCss
                    });
    
    
                    $point.append($productWrapper)
                    $point.children('.lookbook__item-product').append('<img class="lookbook__item-product-loading" src="css/img/alo.gif" alt="Loading">');
                    $documentFragment.append($point);
                });
    
                $(this).append($documentFragment);
            }
        });
    }

    const handlePointHover = async function () {
        const $point = $(this);
        const productId = $point.data('product-id');
        const quantity = $point.data('quantity');
        const isPhantom = $point.data('is-phantom');
        $point.attr('aria-expanded', 'true');
        if ($point.data('rendered')) {
            return;
        }
        $point.data('rendered', true);
        await $.get("_/3-2-" + productId, {
            __template: "partials/common/lookbook-product.html",
            __collection: "product-presentation"
        }).done(function (response) {
            $point.find(".lookbook__item-product-loading").css("display", "none");
            $point.children('.lookbook__item-product').append(response.template);
        });

        $(".cart-js").on("click", () => {
            const url = $(this).find(".cart-js").data("url");

            if (isPhantom) {
                location.href = url;
            } else {
                addAllToCart([{ "productId": productId, "quantity": quantity }]);
            }
        });
    };

    return {
        init: init
    }
})();
`